module.exports = __webpack_public_path__ + "static/media/projectileDiagram3.ed2d619b.svg";